var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bell blue@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc-UI",
    stroke: "none",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Info-modal---No-Member",
    transform: "translate(-931.000000, -872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bell-blue",
    transform: "translate(931.000000, 872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_bell_632304_000000",
    fill: "#0074D9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02311111,0.149046154 L6.02296296,0.149046154 C6.27355556,0.118984615 6.5223917,0.353369231 6.51834074,0.615384615 L6.51834074,1.10576923 C7.34422222,1.21273846 8.05140741,1.61358462 8.58322963,2.18269231 C9.20823704,2.85084615 9.6029037,3.74095385 9.76841481,4.68746154 L10.3610074,8.07207692 C10.4836889,8.77461538 10.7348444,8.91884615 11.0924889,9.16343077 C11.2713185,9.28601538 11.4894948,9.41643077 11.6804593,9.649 C11.8714237,9.88156923 11.9998963,10.2211077 11.9998963,10.6153385 C11.9998963,11.2890154 11.463437,11.8461077 10.8147111,11.8461077 L8.2916,11.8461077 C8.21456296,13.0450308 7.24761481,13.9999538 6.07397037,13.9999538 C4.90032593,13.9999538 3.93330815,13.0450308 3.85634074,11.8461077 L1.33322963,11.8461077 C0.684503704,11.8461077 0.148044444,11.2890154 0.148044444,10.6153385 C0.148044444,10.2211231 0.276503704,9.88156923 0.467481481,9.649 C0.658459259,9.41643077 0.876637037,9.28602769 1.05545185,9.16343077 C1.4130963,8.91883077 1.66424889,8.7746 1.78693333,8.07207692 L2.37952593,4.68746154 C2.54503704,3.741 2.9397037,2.85096923 3.56471111,2.18269231 C4.09656296,1.61358462 4.80379259,1.21274 5.6296,1.10576923 L5.6296,0.615384615 C5.62611852,0.388830769 5.8061037,0.174887692 6.02311111,0.149046154 Z M4.76848148,11.8461231 L7.37959259,11.8461231 C7.30436148,12.5426308 6.7679037,13.0768923 6.07403704,13.0768923 C5.38017037,13.0768923 4.84371111,12.5426308 4.76848148,11.8461231 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.3 L3,12.3",
    id: "Line-2",
    stroke: "#f0f0f0",
    strokeWidth: 0.8,
    strokeLinecap: "square"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlue);
export default __webpack_public_path__ + "static/media/bell-blue.8ae02ec6d85f4d3274f2262ff8d5ce75.svg";
export { ForwardRef as ReactComponent };